module.exports = __webpack_public_path__ + "static/media/logo-weeflow.331eafd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/logo-weeflow.png
// module id = 878
// module chunks = 0